/* FAQ content for /faqs, grouped by category.
   Source: "Website Content — Full Rewrite" (FAQs section).
   The FAQPage structured data is built from this same list in Faq.js,
   so editing a question here updates the page and the schema together. */

export const FAQ_INTRO =
    "Find answers to commonly asked questions about Jainam Jivika Foundation, Life Saver Army and how you can support voluntary blood donation.";

export const FAQ_CATEGORIES = [
    {
        title: "About Jainam Jivika Foundation",
        items: [
            {
                q: "What is Jainam Jivika Foundation?",
                a: "Jainam Jivika Foundation is a registered non-profit organisation working to promote voluntary blood donation through Life Saver Army.",
            },
            {
                q: "What are the main focus areas of Jainam Jivika Foundation?",
                a: "Our primary focus is Life Saver Army, our flagship initiative, through which we aim to increase awareness of blood donation, encourage voluntary donors and support blood donation initiatives.",
            },
            {
                q: "When was Jainam Jivika Foundation established?",
                a: "Jainam Jivika Foundation was established in 2017.",
            },
            {
                q: "Is Jainam Jivika Foundation a registered organisation?",
                a: "Yes. Jainam Jivika Foundation is a registered non-profit organisation in India.",
            },
            {
                q: "Where is Jainam Jivika Foundation headquartered?",
                a: "Our registered office is in Pune, Maharashtra, India.",
            },
        ],
    },
    {
        title: "Life Saver Army",
        items: [
            {
                q: "What is Life Saver Army?",
                a: "Life Saver Army is the flagship blood donation initiative of Jainam Jivika Foundation.",
            },
            {
                q: "What does Life Saver Army do?",
                a: "It promotes voluntary blood donation, organises donation camps and helps connect blood donors with patients when required.",
            },
            {
                q: "Who can join Life Saver Army?",
                a: "Anyone interested in supporting voluntary blood donation can register as a volunteer or blood donor.",
            },
            {
                q: "Do you organise blood donation camps?",
                a: "Yes. We organise blood donation camps in collaboration with hospitals, blood banks and partner organisations.",
            },
            {
                q: "Can hospitals work with Life Saver Army?",
                a: "Yes. We welcome partnerships with hospitals, blood banks and healthcare organisations.",
            },
            {
                q: "How can I request blood during an emergency?",
                a: "You can contact our team through the details provided on our website.",
            },
            {
                q: "Is there a fee to join?",
                a: "No. Registration is free of charge.",
            },
        ],
    },
    {
        title: "Volunteer Opportunities",
        items: [
            {
                q: "How can I become a volunteer?",
                a: "Complete the volunteer registration form on our website.",
            },
            {
                q: "Do I need previous experience?",
                a: "No. Guidance and support are provided where required.",
            },
            {
                q: "Are remote volunteering opportunities available?",
                a: "Yes. Volunteers can assist with awareness and digital activities.",
            },
            {
                q: "Can students volunteer?",
                a: "Yes. Students are welcome to take part in our activities.",
            },
            {
                q: "How are volunteer hours recorded?",
                a: "Participation is recorded for registered volunteers.",
            },
            {
                q: "Is there an age requirement?",
                a: "Volunteers of different age groups can participate. Blood donors must meet the required medical criteria.",
            },
            {
                q: "What can volunteers help with?",
                a: "Volunteers assist with blood donation camps, awareness activities and donor registration.",
            },
        ],
    },
    {
        title: "Donations",
        items: [
            {
                q: "How can I donate?",
                a: "Donations can be made online or by bank transfer.",
            },
            {
                q: "Are donations eligible for tax benefits?",
                a: "Yes. Eligible donations qualify for tax benefits under Section 80G.",
            },
            {
                q: "How are donations used?",
                a: "They support blood donation camps, awareness activities and related operational costs.",
            },
            {
                q: "Can I make a one-off or regular donation?",
                a: "Yes. Both options are available.",
            },
            {
                q: "Will I receive a receipt?",
                a: "Yes. A receipt is issued for every donation.",
            },
            {
                q: "Can I donate goods instead of money?",
                a: "Yes. In-kind donations may be accepted where appropriate.",
            },
            {
                q: "Can I support a specific blood donation activity?",
                a: "Yes. Please contact our team to discuss available opportunities.",
            },
            {
                q: "Can I donate anonymously?",
                a: "Yes. Anonymous donations are accepted upon request.",
            },
        ],
    },
    {
        title: "Corporate Partnerships",
        items: [
            {
                q: "How can organisations work with Jainam Jivika Foundation?",
                a: "Organisations can support blood donation camps, awareness programmes and CSR initiatives.",
            },
            {
                q: "Do you offer CSR opportunities?",
                a: "Yes. We work with organisations on CSR projects related to blood donation.",
            },
            {
                q: "Can companies make financial contributions?",
                a: "Yes. Corporate donations are welcomed.",
            },
        ],
    },
    {
        title: "Events and Campaigns",
        items: [
            {
                q: "What types of events do you organise?",
                a: "We organise blood donation camps and public awareness programmes.",
            },
            {
                q: "Can I volunteer at your events?",
                a: "Yes. Volunteers are encouraged to participate.",
            },
            {
                q: "How can I keep up to date with upcoming events?",
                a: "Follow our website and official social media channels.",
            },
            {
                q: "Do you run awareness campaigns?",
                a: "Yes. We regularly promote awareness of voluntary blood donation.",
            },
        ],
    },
    {
        title: "Partnerships",
        items: [
            {
                q: "How can NGOs collaborate with Jainam Jivika Foundation?",
                a: "NGOs can work with us on awareness activities and community programmes.",
            },
            {
                q: "Do NGOs pay to collaborate?",
                a: "No. There is no fee for genuine partnerships.",
            },
            {
                q: "Can smaller organisations collaborate?",
                a: "Yes. We welcome organisations of all sizes.",
            },
        ],
    },
    {
        title: "Impact",
        items: [
            {
                q: "How do you measure your impact?",
                a: "We monitor blood donation camps, donor registrations and community participation.",
            },
            {
                q: "Can I see how my donation has been used?",
                a: "Yes. We share updates on our activities and outcomes.",
            },
        ],
    },
    {
        title: "Miscellaneous",
        items: [
            {
                q: "Can I apply for an internship?",
                a: "Yes. Internship opportunities are available when announced.",
            },
            {
                q: "How can I contact Jainam Jivika Foundation?",
                a: "You can contact us by phone, email or through our website.",
            },
            {
                q: "Does Life Saver Army operate across India?",
                a: "We continue to expand our activities across different parts of the country.",
            },
            {
                q: "Can I suggest an idea or project?",
                a: "Yes. We welcome constructive suggestions.",
            },
            {
                q: "Is Jainam Jivika Foundation affiliated with any religious organisation?",
                a: "No. Our activities are open to everyone regardless of background.",
            },
            {
                q: "Can I apply for a full-time role?",
                a: "Yes. Vacancies are published when available.",
            },
            {
                q: "Do volunteers receive certificates?",
                a: "Yes. Certificates may be issued for eligible participation.",
            },
            {
                q: "What is the best way to support Life Saver Army?",
                a: "You can donate blood, volunteer, make a financial contribution or help raise awareness.",
            },
            {
                q: "Can schools and colleges work with you?",
                a: "Yes. We work with educational institutions to organise blood donation activities.",
            },
            {
                q: "How can influencers support Life Saver Army?",
                a: "They can help increase awareness and encourage voluntary blood donation through their platforms.",
            },
        ],
    },
];
